/**
 * feature-flags.js
 *
 * Beta feature flag system.
 * Loaded synchronously (no defer) so window.betaFlags is available
 * before all deferred scripts execute.
 *
 * ACTIVATION
 *   ?beta=flag1          — activate one flag
 *   ?beta=flag1,flag2    — activate multiple flags
 *   ?beta=clear          — wipe all stored flags
 *
 * Flags accumulate across navigation within the same tab.
 * Closing the tab clears all flags (sessionStorage, not localStorage).
 *
 * USAGE IN JS
 *   if (window.betaFlags.newCheckout) { ... }
 */
(function () {
  var STORAGE_KEY = 'betaFlags';
  var PARAM_NAME  = 'beta';

  // 1. Load previously stored flags
  var stored = {};
  try {
    var raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) stored = JSON.parse(raw);
    if (typeof stored !== 'object' || Array.isArray(stored)) stored = {};
  } catch (e) {
    stored = {};
  }

  // 2. Parse flags from current URL
  var params = new URLSearchParams(window.location.search);
  var paramValue = params.get(PARAM_NAME);

  if (paramValue !== null) {
    if (paramValue.trim() === 'clear') {
      stored = {};
    } else {
      paramValue.split(',').forEach(function (flag) {
        var trimmed = flag.trim();
        if (trimmed) stored[trimmed] = true;
      });
    }

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
    } catch (e) {
      // sessionStorage unavailable (private browsing quota, etc.)
    }
  }

  // 3. Expose on window for all subsequent scripts
  window.betaFlags = stored;

  // 4. Log active flags for debugging
  var activeFlags = Object.keys(stored);
  if (activeFlags.length > 0) {
    console.log('[betaFlags] Active flags:', activeFlags.join(', '));
  }
})();
